import { FASTElement as h, html as p, attr as d } from "@microsoft/fast-element";
import { tableCellStyles as c } from "./tcell.styles.js";
var f = Object.defineProperty, l = (r, n, o, u) => {
  for (var t = void 0, i = r.length - 1, a; i >= 0; i--)
    (a = r[i]) && (t = a(n, o, t) || t);
  return t && f(n, o, t), t;
};
const s = class s extends h {
  constructor() {
    super(...arguments), this.align = "left", this.width = "auto";
  }
  widthChanged() {
    this.$fastController.isConnected && this.updateWidth();
  }
  connectedCallback() {
    super.connectedCallback(), this.updateWidth();
  }
  updateWidth() {
    this.style.width = this.width;
  }
};
s.definition = {
  name: "tcell",
  template: () => p` <slot></slot>`,
  styles: () => c
};
let e = s;
l([
  d
], e.prototype, "align");
l([
  d
], e.prototype, "width");
export {
  e as TableCell
};
